import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AppLayout from './layout/AppLayout';
import { ITENS_APP, ITENS_ADMIN, listarTelasDisponiveis } from './layout/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProdutoList from './pages/produtos/ProdutoList';
import EstoqueList from './pages/estoque/EstoqueList';
import SeparacaoList from './pages/estoque/SeparacaoList';
import DepositosList from './pages/estoque/DepositosList';
import Fornecedores from './pages/Fornecedores';
import TransportadorasList from './pages/transportadoras/TransportadorasList';
import ClientesTenantList from './pages/clientes/ClientesList';
import FuncionariosList from './pages/rh/FuncionariosList';
import PontoList from './pages/rh/PontoList';
import FolhaPagamento from './pages/rh/FolhaPagamento';
import FeriasList from './pages/rh/FeriasList';
import DecimoTerceiroList from './pages/rh/DecimoTerceiroList';
import RescisaoList from './pages/rh/RescisaoList';
import ComissoesList from './pages/rh/ComissoesList';
import MetasList from './pages/rh/MetasList';
import ValeBeneficioList from './pages/rh/ValeBeneficioList';
import EmpresasList from './pages/empresas/EmpresasList';
import OrdensCompraList from './pages/compras/OrdensCompraList';
import NotasEntradaList from './pages/compras/NotasEntradaList';
import RecomendacaoCompraList from './pages/compras/RecomendacaoCompraList';
import PropostasList from './pages/vendas/PropostasList';
import PedidosList from './pages/vendas/PedidosList';
import NegociacaoList from './pages/vendas/NegociacaoList';
import ClientesList from './pages/admin/ClientesList';
import UsuariosList from './pages/admin/UsuariosList';
import BackupsStub from './pages/admin/BackupsStub';
import ContasPagarList from './pages/financeiro/ContasPagarList';
import ContasPagarCalendario from './pages/financeiro/ContasPagarCalendario';
import ContasReceberList from './pages/financeiro/ContasReceberList';
import ContasReceberCalendario from './pages/financeiro/ContasReceberCalendario';
import RessarcimentoStList from './pages/financeiro/RessarcimentoStList';
import RegioesEntregaList from './pages/configuracoes/RegioesEntregaList';
import DadosBancariosEmpresa from './pages/configuracoes/DadosBancariosEmpresa';
import AuditoriaList from './pages/admin/AuditoriaList';

function AppShell() {
  const { perfil, usuario } = useAuth();

  // Uma tela só fica visível se o perfil já permite por padrão E (se o usuário tiver
  // permissões personalizadas) ela estiver marcada — a personalização nunca amplia o
  // que o perfil já bloqueia, só restringe dentro disso.
  const telasCustom = Array.isArray(usuario?.telas_permitidas) ? usuario.telas_permitidas : null;
  const podeVerTela = (chave) => {
    const tela = listarTelasDisponiveis().find(t => t.chave === chave);
    const permiteEssePerfil = !tela || !tela.perfis || tela.perfis.includes(perfil);
    if (!permiteEssePerfil) return false;
    return telasCustom === null || telasCustom.includes(chave);
  };

  const [pagina, setPagina] = useState('dashboard');
  const itens = ITENS_APP
    .map(item => item.grupo ? { ...item, grupo: item.grupo.filter(sub => podeVerTela(sub.chave)) } : item)
    .filter(item => item.grupo ? item.grupo.length > 0 : podeVerTela(item.chave));

  return (
    <AppLayout paginaAtiva={pagina} onNavegar={setPagina} itens={itens}>
      {pagina === 'dashboard' && podeVerTela('dashboard') && <Dashboard />}
      {pagina === 'produtos' && podeVerTela('produtos') && <ProdutoList />}
      {pagina === 'estoque' && podeVerTela('estoque') && <EstoqueList />}
      {pagina === 'separacao' && podeVerTela('separacao') && <SeparacaoList />}
      {pagina === 'depositos' && podeVerTela('depositos') && <DepositosList />}
      {pagina === 'empresas' && podeVerTela('empresas') && <EmpresasList />}
      {pagina === 'regioes-entrega' && podeVerTela('regioes-entrega') && <RegioesEntregaList />}
      {pagina === 'dados-bancarios' && podeVerTela('dados-bancarios') && <DadosBancariosEmpresa />}
      {pagina === 'auditoria' && podeVerTela('auditoria') && <AuditoriaList />}
      {pagina === 'ordens-compra' && podeVerTela('ordens-compra') && <OrdensCompraList />}
      {pagina === 'notas-entrada' && podeVerTela('notas-entrada') && <NotasEntradaList />}
      {pagina === 'recomendacao-compra' && podeVerTela('recomendacao-compra') && <RecomendacaoCompraList />}
      {pagina === 'propostas' && podeVerTela('propostas') && <PropostasList />}
      {pagina === 'pedidos' && podeVerTela('pedidos') && <PedidosList />}
      {pagina === 'negociacao' && podeVerTela('negociacao') && <NegociacaoList />}
      {pagina === 'fornecedores' && podeVerTela('fornecedores') && <Fornecedores />}
      {pagina === 'transportadoras' && podeVerTela('transportadoras') && <TransportadorasList />}
      {pagina === 'clientes' && podeVerTela('clientes') && <ClientesTenantList />}
      {pagina === 'funcionarios' && podeVerTela('funcionarios') && <FuncionariosList />}
      {pagina === 'ponto' && podeVerTela('ponto') && <PontoList />}
      {pagina === 'vale-transporte' && podeVerTela('vale-transporte') && <ValeBeneficioList campo="vale_transporte" titulo="Vale Transporte" />}
      {pagina === 'vale-alimentacao' && podeVerTela('vale-alimentacao') && <ValeBeneficioList campo="vale_alimentacao" titulo="Vale Alimentação" />}
      {pagina === 'folha-pagamento' && podeVerTela('folha-pagamento') && <FolhaPagamento />}
      {pagina === 'ferias' && podeVerTela('ferias') && <FeriasList />}
      {pagina === 'decimo-terceiro' && podeVerTela('decimo-terceiro') && <DecimoTerceiroList />}
      {pagina === 'rescisao' && podeVerTela('rescisao') && <RescisaoList />}
      {pagina === 'comissoes' && podeVerTela('comissoes') && <ComissoesList />}
      {pagina === 'metas' && podeVerTela('metas') && <MetasList />}
      {pagina === 'contas-pagar' && podeVerTela('contas-pagar') && <ContasPagarList />}
      {pagina === 'contas-pagar-calendario' && podeVerTela('contas-pagar-calendario') && <ContasPagarCalendario />}
      {pagina === 'contas-receber' && podeVerTela('contas-receber') && <ContasReceberList />}
      {pagina === 'contas-receber-calendario' && podeVerTela('contas-receber-calendario') && <ContasReceberCalendario />}
      {pagina === 'ressarcimento-st' && podeVerTela('ressarcimento-st') && <RessarcimentoStList />}
    </AppLayout>
  );
}

function AdminShell() {
  const [pagina, setPagina] = useState('clientes');

  return (
    <AppLayout paginaAtiva={pagina} onNavegar={setPagina} itens={ITENS_ADMIN}>
      {pagina === 'clientes' && <ClientesList />}
      {pagina === 'usuarios' && <UsuariosList />}
      {pagina === 'backups' && <BackupsStub />}
    </AppLayout>
  );
}

function AreaLogada() {
  const { tenantId } = useAuth();
  return tenantId === null ? <AdminShell /> : <AppShell />;
}

function RotaProtegida({ children }) {
  const { usuario, carregando } = useAuth();
  if (carregando) return null;
  if (!usuario) return <Navigate to="/login" replace />;
  return children;
}

function RotaPublica({ children }) {
  const { usuario, carregando } = useAuth();
  if (carregando) return null;
  if (usuario) return <Navigate to="/produtos" replace />;
  return children;
}

function AppInterno() {
  return (
    <Routes>
      {/* TODO: quando a landing page voltar, trocar este redirect fixo por <RotaPublica><LandingPage /></RotaPublica> */}
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<RotaPublica><Login /></RotaPublica>} />
      <Route path="*" element={<RotaProtegida><AreaLogada /></RotaProtegida>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppInterno />
      </AuthProvider>
    </BrowserRouter>
  );
}
